
import { ARRAY_TIPO_MINUTAS, DESPACHO, ITipoMinuta, TipoMinuta } from "./TipoMinuta";
import { CategoriaMinuta } from "./Categoria";
import { MovimentoGEDTO } from "./MinutaMovimentos";
import { makeObservable, observable } from "mobx";

export class IModelo {
   nome: string;
   tipoMinuta: ITipoMinuta;
   categoria?: CategoriaMinuta;
   descricao?: string;
   codigo?: number;
   conteudo?: any; //base64
   conteudoHtml?: string;//TODO Deprecated
   gabinete?: string;
   movimentoCnj?: MovimentoGEDTO;
   publicavel?: boolean;
   codUnAdmPublicacao?: number;
   incluirAposPauta?: boolean;

   constructor() {
      makeObservable(this, {
         nome: observable,
         categoria: observable,
         conteudo: observable,
         movimentoCnj: observable,
         publicavel: observable,
         codUnAdmPublicacao: observable,
         incluirAposPauta: observable
      });
   }

   static extrairCodigoTipoMinuta(tipoMinuta: unknown): number {
      if (typeof tipoMinuta === 'number' && Number.isFinite(tipoMinuta)) {
         return tipoMinuta;
      }

      if (typeof tipoMinuta === 'string') {
         const convertido = Number(tipoMinuta);
         return Number.isFinite(convertido) ? convertido : NaN;
      }

      if (tipoMinuta && typeof tipoMinuta === 'object') {
         const codigo = (tipoMinuta as any).codigo;
         if (codigo === undefined || codigo === null) {
            return NaN;
         }

         // Alguns payloads chegam com `codigo` aninhado mais de um nível.
         if (typeof codigo === 'object') {
            return IModelo.extrairCodigoTipoMinuta(codigo);
         }

         const convertido = Number(codigo);
         return Number.isFinite(convertido) ? convertido : NaN;
      }

      return NaN;
   }

   static toModeloMinutaBack(modelo: IModelo) {

      const modeloNovo = new ModeloMinutaBack();
      const tipoMinutaCodigo = IModelo.extrairCodigoTipoMinuta((modelo as any)?.tipoMinuta);
      modeloNovo.tipoMinuta = Number.isFinite(tipoMinutaCodigo) ? tipoMinutaCodigo : TipoMinuta.DESPACHO;
      modeloNovo.id = modelo.codigo;
      modeloNovo.nome = modelo.nome;
      modeloNovo.categoria = modelo.categoria;
      modeloNovo.descricao = modelo.descricao;
      modeloNovo.conteudo = modelo.conteudo;
      modeloNovo.gabinete = modelo.gabinete;
      modeloNovo.movimentoCnj = modelo.movimentoCnj;
      modeloNovo.publicavel = modelo.publicavel;
      modeloNovo.codUnAdmPublicacao = modelo.codUnAdmPublicacao;
      modeloNovo.incluirAposPauta = modelo.incluirAposPauta;
      return modeloNovo;
   }

   private static resolverTipoMinuta(tipoMinuta: number | ITipoMinuta) {
      const codigo = IModelo.extrairCodigoTipoMinuta(tipoMinuta);

      const tipoEncontrado = ARRAY_TIPO_MINUTAS.find(tipo => tipo.codigo === codigo);
      return tipoEncontrado || ARRAY_TIPO_MINUTAS[0];
   }

   static novo(modelo: ModeloMinutaBack) {
      if (!modelo) {
         modelo = { nome: "", tipoMinuta: 1, id: undefined, gabinete: null, conteudo: ""};
      }

      const modeloNovo = new IModelo();
      // Garante que tipoMinuta seja sempre um objeto do tipo correto.
      modeloNovo.tipoMinuta = IModelo.resolverTipoMinuta((modelo as any).tipoMinuta);
      modeloNovo.codigo = modelo.id;

      // Copia as demais propriedades, exceto tipoMinuta e id para nao sobrescrever o objeto normalizado acima.
      const { id: _, tipoMinuta: __, ...rest } = modelo as any;
      Object.assign(modeloNovo, rest);
      // Garante que movimentoCnj seja instância MobX
      if (modeloNovo.movimentoCnj && typeof modeloNovo.movimentoCnj === 'object') {
         modeloNovo.movimentoCnj = MovimentoGEDTO.novo(modeloNovo.movimentoCnj);
      }
      return modeloNovo;
   }
}

export class ModeloMinutaBack {
   nome: string;
   tipoMinuta: number;
   categorias?: [CategoriaMinuta];
   categoria?: CategoriaMinuta;
   descricao?: string;
   id: number;
   conteudo: any; // base64
   gabinete: string;
   movimentoCnj?: MovimentoGEDTO;
   publicavel?: boolean;
   codUnAdmPublicacao?: number;
   incluirAposPauta?: boolean;
}
